import React, { FC } from 'react';
import { v4 as uuid } from 'uuid';

import useCookie from '../../../hooks/useCookie';
import useTranslation from '../../../hooks/useTranslation';
import { CookieType } from '../../../utils/cookie-utils';
import CookieFormSubmit from './CookieFormSubmit';
import CookieSelect from './CookieSelect';

interface Props {
    cookies: CookieType;
    onCloseModal?: () => void;
}

const CookieForm: FC<Props> = ({ cookies, onCloseModal }) => {
    const { modal, success } = useTranslation();
    const { consents, onChange, onAcceptAll, onSave, saved } = useCookie(cookies, success.timeout, onCloseModal);

    return (
        <form className="cookie-consent-form">
            <div className="checkbox">
                {Object.values(cookies).map((cookie) => (
                    <CookieSelect
                        id={uuid()}
                        key={cookie.cookieName}
                        cookie={cookie}
                        onChange={onChange}
                        checked={consents[cookie.cookieName]}
                    />
                ))}
            </div>
            <CookieFormSubmit
                actions={[
                    { type: 'secondary', onClick: onSave, text: modal.onlyNecessary },
                    { type: 'primary', onClick: onAcceptAll, text: modal.acceptAll },
                ]}
                showSuccesss={saved}
                successText={success.description}
            />
        </form>
    );
};

export default CookieForm;
